export const returnToWebAppContext = backNav => (dispatch, getState) => {
  const { sessionId, paused } = getState().consultationReducer;
  if (paused || backNav) {
    const reactSessionId = document.getElementById('reactSessionId');
    if (reactSessionId) {
      reactSessionId.value = sessionId;
    }
    const submitReturn = backNav
      ? document.getElementById('submitPrevToWebFlow')
      : document.getElementById('submitReturnToWebFlow');
    if (submitReturn) {
      submitReturn.click();
      return dispatch({ type: 'consultation/EMBEDDED_FORM_SUBMITTED' });
    }
    // eslint-disable-next-line no-console
    console.error('Unable to find submitReturnToWebFlow element for submission');
    return dispatch({ type: 'consultation/EMBEDDED_FORM_NOT_FOUND' });
  }
  return dispatch({ type: 'consultation/CONSULTATION_NOT_PAUSED' });
};
